/*
 * @Author: wblijinyang
 * @FilePath: /code/mall-fe/src/views/web/product/Detail/index.ts
 * @Description: 移动端商品详情入口文件
 */
import ProductDetail from './Detail';

export default ProductDetail;
